import { createLazyComponent, LazyAction, LazyImport, type LazyComponent, LazyModule, registerLazyOrchestrator, } from "owa-bundling";
import type { AccountLinkProps } from "./components/AccountLinkSection";
import type * as lazyIndex from "./lazyIndex";
import type * as backgroundIndex from "./backgroundIndex";
import { getAccountLinkStore } from "./store/store";
import { onCoprincipalBootStateChanged } from "owa-account-source-list-store";
import { accountAddedFromAccountConfigDialog, accountConfigDialogClosed } from "owa-account-config";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaCloudCacheLink" */ "./lazyIndex"), { name: "OwaCloudCacheLink" });
const fullModuleImport = new LazyImport(lazyModule, m => m);

// Store initialization and account orchestrators do not need the linking UI.
const backgroundLazyModule: LazyModule<typeof backgroundIndex> = new LazyModule(() => isGlobalFeatureEnabled("perf-memory-defer-idle-ui", true /* dontThrowErrorIfNotInitialized */) &&
    !isGlobalFeatureEnabled("perf-memory-defer-account-linking-ui-ripcord", true /* dontThrowErrorIfNotInitialized */)
    ? import(/* webpackChunkName: "OwaCloudCacheLinkBackground" */ "./backgroundIndex")
    : fullModuleImport.import(), { name: "OwaCloudCacheLinkBackground" });

export const AccountLinkSection: LazyComponent<AccountLinkProps, unknown, void> = createLazyComponent(lazyModule, m => m.AccountLinkSection);

export const AccountLinkingAutoOpenDialogs: LazyComponent<unknown, unknown, void> = createLazyComponent(lazyModule, m => m.AccountLinkingAutoOpenDialogs, undefined, undefined, {
    onlyImportIf: () => {
        const store = getAccountLinkStore();
        return !!store.accountToLink || !!store.accountToSignIn;
    },
});

export const lazyInitializeCloudCacheLinkStore: LazyAction<typeof lazyIndex.initializeCloudCacheLinkStore, typeof backgroundLazyModule> = new LazyAction(backgroundLazyModule, m => m.initializeCloudCacheLinkStore);

export const lazyInitializeCloudCacheLinkStoreAndDialog: LazyAction<typeof lazyIndex.initializeCloudCacheLinkStoreAndDialog, typeof backgroundLazyModule> = new LazyAction(backgroundLazyModule, m => m.initializeCloudCacheLinkStoreAndDialog);

registerLazyOrchestrator(onCoprincipalBootStateChanged, backgroundLazyModule, m => m.onCoprincipalAccountAddedOrchestrator);

registerLazyOrchestrator(accountAddedFromAccountConfigDialog, backgroundLazyModule, m => m.onAccountAddedFromAccountConfigDialogOrchestrator);

registerLazyOrchestrator(accountConfigDialogClosed, backgroundLazyModule, m => m.onAccountConfigDialogClosedOrchestrator);
